import Moment from 'moment';
import { useTranslation } from "react-i18next";
const ColumnsErrorStudy = () =>{
  
  const [t, i18n] = useTranslation();
  return [
  {
    Header: t("error-study-list.patient-id"),
    accessor: "id",
    headerStyle: {padding:"15px"},
    rowStyle: { padding: "15px"},
    className: "column-studyerror-id-header",
    classChildName: "break-word cursor-pointer column-studyerror-id-row",
    sorting: true
    
  },
  {
    Header:  t("error-study-list.hospital-code"),
    accessor: "hospitalCode",
    className: "column-studyerror-details-header",
    classChildName: "break-word column-studyerror-details-row",
    headerStyle: {padding:"15px"},
    rowStyle: { padding: "15px"},
    sorting: true
  },
  {
      Header: t("error-study-list.error-code"),
      accessor: "errorCode",
      className: "column-studyerror-errorcode-header",
      classChildName: "break-word column-studyerror-errorcode-row",
      headerStyle: {padding:"15px"},
      rowStyle: { padding: "15px"},
      sorting: true
  },
  {
      Header: t("error-study-list.description"),
      accessor: "errorDescription",
      className: "column-studyerror-description-header",
      classChildName: "break-word column-studyerror-details-row",
      headerStyle: {padding:"15px"},
      rowStyle: { padding: "15px"},
      sorting: true
  },
  {
      Header: t("error-study-list.action"),
      accessor: "actionBy",
      className: "column-studyerror-action-header",
      classChildName: "break-word column-studyerror-action-row",
      headerStyle: {padding:"15px"},
      rowStyle: { padding: "15px"},
      sorting: true
  },
  {
      Header: t("error-study-list.error-date"),
    //   accessor:"createdDate",
      accessor: d => {
        return Moment(d.createdDate)
          .local()
          .format("DD-MM-YYYY hh:mm:ss A")
      },
    className: "column-studyerror-errordate-header",
      classChildName: "break-word column-studyerror-errordate-row",
    headerStyle: {padding:"15px"},
    rowStyle: {},
    sorting: true
  },
  {
      Header: t("error-study-list.object-path"),
      accessor: "objectName",
      className: "column-studyerror-objectpath-header",
      classChildName: "break-word column-studyerror-objectpath-row",
      headerStyle: {padding:"15px"},
      sorting: true,
      rowStyle:{wordWrap:'break-word',wordBreak:'break-all',padding: "15px"}
  }
]};
export default ColumnsErrorStudy;
